// https://reactjs.org/docs/hooks-reference.html#lazy-initial-state
// https://javascript.plainenglish.io/use-constructor-in-react-functional-component-with-custom-hooks-e0770e92b840
// https://blog.csdn.net/qq_20567691/article/details/106035547

import {useEffect,useState,useMemo,useContext} from 'react';
import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar ,IonBackButton,IonButtons,IonIcon,IonItem,IonButton,

  IonLabel,IonInput,IonSelect,IonSelectOption,
  IonDatetime,
  useIonToast,
  IonCheckbox,
  IonTextarea
} from '@ionic/react';


import { happy,chevronBackOutline } from 'ionicons/icons';

import { useHistory,useLocation } from "react-router";



import {restPatch,uploadAsset,uploadBinary, uploadGeneric,useRestGetTextFile,restPutTextFile} from "../hooks/AdminHttp";
import enums from '../type/enums';

import styles from '../common/styles.module.css'
import { AppContext } from '../global';
import { genericPatchForeign } from '../hooks/GenericHttp';
import NullableTextField from '../components/NullableTextField';
import NullableSelect from '../components/NullableSelect';
import GenericField from '../components/GenericField';


interface Json {[key:string]:any};

const GenericEdit: React.FC<{
  meta:Json,
  field:string,
  item:Json,
  role:string,
  entities:Json,
  onCloseClicked:()=>void
}> = ({meta,field, item,role,entities, onCloseClicked}) => {

  let fieldMeta = meta.fields[field ];

  const [state,setState] = useState<{[key:string]:any}>(item?item:{});

  const [toastPresent,toastDismiss] = useIonToast();

  const [content,getContent] = useRestGetTextFile(fieldMeta.edit_get_path + 'config/' + item[field]);



  console.log('field meta:' + JSON.stringify(fieldMeta));

  useEffect(()=>{
    
    getContent({
      filetype:'config',
      suffix:'ini',
      role:role
    });

  },[]);

  // useEffect(()=>{
    
  //   console.log("content: " + content);

  //   setState({...state, content: content});

  // },[content]);


  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>

          <IonTitle>编辑{meta.name}</IonTitle>
          <IonButtons slot="end">
            <IonButton onClick={onCloseClicked}>取消</IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>


          <IonTextarea autoGrow={true} value={state.content?state.content:content  } onIonChange={e =>{
              if (e )
              setState({...state, content: e.detail.value});
          }}  />
      

       
      </IonContent>


      <IonItem lines="none">
          <IonButton slot="end"  size="default" color="secondary" expand="block" fill="solid" onClick={()=>{

              restPutTextFile(fieldMeta.edit_put_path + 'config/' + item[field] ,{
                filetype:'config',
                suffix:'ini',
                role:role
              },state.content,(resp:any)=>{
                console.log('resp: ' + resp);
                toastPresent({
                  message:"提交成功", 
                  duration: 3000,
                  color:'success' 
                });
  
                onCloseClicked();
  
              },(msg:any)=>{
                toastPresent({
                  message:msg, 
                  duration: 3000,
                  color:'danger' 
                });
              });
            
          }} >确认</IonButton>
      </IonItem>

    </IonPage>
  );
};


export default GenericEdit;